function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata5"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-275.83332)",
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1377",
  d: "m 10.626953,278.8418 a 0.83360657,0.83360657 0 0 0 -0.8339842,0.83398 v 12.64844 H 6.1796875 v -6.61328 A 0.83360657,0.83360657 0 0 0 5.3457031,284.87695 H 1.0566406 a 0.83360657,0.83360657 0 1 0 0,1.66602 h 3.4570313 v 6.61328 a 0.83360657,0.83360657 0 0 0 0.8320312,0.83398 h 5.2812499 a 0.83360657,0.83360657 0 0 0 0.833985,-0.83398 v -12.64648 h 3.085937 v 5.32812 a 0.83360657,0.83360657 0 0 0 0.832031,0.83399 h 4.490235 a 0.83360657,0.83360657 0 1 0 0,-1.66602 h -3.65625 v -5.33008 a 0.83360657,0.83360657 0 0 0 -0.833985,-0.83398 z"
}));

var SvgMapSqWave = function SvgMapSqWave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 21.166666 21.166667",
    height: 80,
    width: 80,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapSqWave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-sq-wave.655e973d.svg";
export { ForwardRef as ReactComponent };